import { useEffect, useState} from "react";
import { useCarrito } from "../context/CarritoContext";
import { X } from "lucide-react";



export default function AddToCartBanner() {
  const { isAddBannerOpen, addedItem, hideAddBanner, openCart } = useCarrito();

  // === Paneo sutil al montar ===
  const [animateIn, setAnimateIn] = useState(false);
  useEffect(() => {
    if (isAddBannerOpen) {
      // Monta "cerrado" y en el próximo frame pasa a "abierto" → dispara la animación
      requestAnimationFrame(() => setAnimateIn(true));
    } else {
      setAnimateIn(false);
    }
  }, [isAddBannerOpen]);

  // Auto-cierre
  useEffect(() => {
    if (!isAddBannerOpen) return;
    const t = setTimeout(() => hideAddBanner(), 3500);
    return () => clearTimeout(t);
  }, [isAddBannerOpen, hideAddBanner]);

  if (!isAddBannerOpen || !addedItem) return null;

  // ---- Helpers ----
  // Pasa "$74.000,50" o "74.000,50" o "74000.50" a número JS
  const toNumberAR = (v) => {
    if (typeof v === "number" && isFinite(v)) return v;
    const s = String(v || "").trim();
    if (!s) return 0;
    const cleaned = s
      .replace(/[^\d.,-]/g, "")
      .replace(/\.(?=\d{3}(?:[.,]|$))/g, ""); // quita separadores de miles tipo 74.000
    const normalized = cleaned.replace(",", ".");
    const n = Number(normalized);
    return isNaN(n) ? 0 : n;
  };

  const formatAR = (n) =>
    Number(n).toLocaleString("es-AR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  // Precio base -> número seguro
  const precioBase = toNumberAR(addedItem.precio);
  if (!precioBase) {
    console.warn("[AddToCartBanner] Precio inválido:", addedItem.precio);
  }

  const precioFmt = `$${formatAR(precioBase)}`;
  const transferFmt = `$${formatAR(Math.round(precioBase * 0.85 * 100) / 100)}`;

  return (
    <div
      role="status"
      aria-live="polite"
      className={`fixed top-[15vh] right-[5vw] z-[90] w-[300px] h-[300px] rounded-none
  will-change-transform transform-gpu transition-[transform,opacity,filter] duration-500 ease-in-out
  ${animateIn
    ? "translate-x-0 opacity-100 scale-100 blur-0"
    : "translate-x-[120%] opacity-0 scale-[0.98] blur-[1px]"
  }
`}
    >
      <div className="bg-white border border-gray-200 shadow-xl p-4">
        {/* Top: imagen + datos */}
        <div className="flex items-start gap-4">
          <img
            src={addedItem.img}
            alt={addedItem.nombre}
            className="w-16 h-16 object-cover flex-shrink-0"
          />

          <div className="flex-1 min-w-0">
            <p className="text-[10px] text-gray-600">¡Producto agregado al carrito!</p>
            <h3 className="text-sm nav-onepalm text-gray-900 truncate mt-1">
              {addedItem.nombre}
            </h3>

            <div className="mt-1 flex flex-wrap items-center gap-x-4 gap-y-1">
              <span className="text-[10px] text-gray-500">
                <span className="text-gray-500 prueba">Talle:</span> {addedItem.talle}
              </span>

              {/* Precio lista con 2 decimales */}
              <span className="text-[12px] proba text-gray-700">{precioFmt}</span>
            </div>
          </div>

          {/* Cerrar */}
          <button
            onClick={hideAddBanner}
            className="p-2 rounded-md hover:bg-gray-100"
            aria-label="Cerrar"
            title="Cerrar"
          >
            <X size={18} />
          </button>
        </div>

        {/* Botón debajo */}
        <div className="mt-4">
          <button
            onClick={() => {
              hideAddBanner();
              openCart();
            }}
            className="w-full nav-onepalm text-[12px] inline-flex items-center justify-center gap-2 border border-transparent bg-gray-600 text-white py-2 h-10 hover:bg-white hover:text-gray-600 hover:border-black transition"
            aria-label="Ver carrito"
          >
            Ver carrito
          </button>
        </div>
      </div>
    </div>
  );
}